var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.41113,
    y: 1.85449,
    width: 9.17787,
    height: 12.1456,
    rx: 0.7821,
    fill: "url(#paint0_linear_284_25071)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12259 1.20217C8.12538 1.16988 8.1268 1.13718 8.1268 1.10415C8.1268 0.494343 7.64197 0 7.0439 0C6.44583 0 5.961 0.494343 5.961 1.10415C5.961 1.13718 5.96242 1.16988 5.96521 1.20217H4.73879C4.47963 1.20217 4.26953 1.41227 4.26953 1.67143V2.38913C4.26953 2.6483 4.47963 2.85839 4.73879 2.85839H9.21478C9.47394 2.85839 9.68404 2.6483 9.68404 2.38913V1.67143C9.68404 1.41227 9.47394 1.20217 9.21478 1.20217H8.12259Z",
    fill: "#AD916F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92676 5.72846L4.26207 6.18276L5.2505 5.4209",
    stroke: "#C4C4C4",
    strokeWidth: 0.39105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92676 8.31635L4.26207 8.77065L5.2505 8.00879",
    stroke: "#C4C4C4",
    strokeWidth: 0.39105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 10.8964L4.22871 11.3968L5.31745 10.5576",
    stroke: "#C4C4C4",
    strokeWidth: 0.39105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69336 5.38624H10.1416",
    stroke: "#C4C4C4",
    strokeWidth: 0.7821,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69336 8.18409H9.62093",
    stroke: "#C4C4C4",
    strokeWidth: 0.7821,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69336 10.981H8.15714",
    stroke: "#C4C4C4",
    strokeWidth: 0.7821,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_25071",
    x1: 7.00007,
    y1: 1.85449,
    x2: 7.00007,
    y2: 14.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem2);
export default __webpack_public_path__ + "static/media/item2.391a94a7c54b1aef49d18102a8ab940c.svg";
export { ForwardRef as ReactComponent };